<template>
<button type="button" aria-label="Close" @click.prevent.capture="emitClose">
    <slot />
</button>
</template>
<script setup lang="ts">
import { emitClose } from '#src/js/modalData.mts'
</script>
